// src/components/ProtectedRoute.jsx
import React from 'react';
// import { Navigate, useLocation } from 'react-router-dom';

// export default function ProtectedRoute({ children }) {
//   const user = JSON.parse(localStorage.getItem('user'));
//   const location = useLocation();

//   if (!user) {
//     return <Navigate to="/login" state={{ from: location.pathname }} replace />;
//   }

//   return children;
// }

// ProtectedRoute.jsx
import { Navigate, useLocation } from 'react-router-dom';

export default function ProtectedRoute({ children }) {
  const user = JSON.parse(localStorage.getItem('user'));
  const location = useLocation();

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname + location.search }} replace />;
  }

  return children;
}


